// 역할/권한 상수 및 유틸

export const Roles = {
    OPERATOR: 'OPERATOR',
    // GA (master/unit/branch)
    GA_MASTER_ADMIN: 'GA_MASTER_ADMIN',
    GA_MASTER_DEPUTY_ADMIN: 'GA_MASTER_DEPUTY_ADMIN',
    GA_LEADER: 'GA_LEADER',
    GA_DEPUTY_LEADER: 'GA_DEPUTY_LEADER',
    GA_MANAGER: 'GA_MANAGER',
    GA_OPERATION_MANAGER: 'GA_OPERATION_MANAGER',
    // legacy/호환: 총무(시드/운영 데이터에 존재)
    GA_AFFAIRS: 'GA_AFFAIRS',
    GA_PLANNER: 'GA_PLANNER',
    GA_BRANCH_MANAGER: 'GA_BRANCH_MANAGER',
    GA_DEPUTY_BRANCH_MANAGER: 'GA_DEPUTY_BRANCH_MANAGER',
    GA_OTHER_ADMIN: 'GA_OTHER_ADMIN',
    GA_ETC: 'GA_ETC',
    // INSURER (master/unit/branch)
    INSURER_MASTER_ADMIN: 'INSURER_MASTER_ADMIN',
    INSURER_MASTER_DEPUTY_ADMIN: 'INSURER_MASTER_DEPUTY_ADMIN',
    INSURER_MANAGER: 'INSURER_MANAGER',
    INSURER_OPERATION_MANAGER: 'INSURER_OPERATION_MANAGER',
    INSURER_LEADER: 'INSURER_LEADER',
    // legacy/호환: 본부장(시드/운영 데이터에 존재)
    INSURER_HEAD_MANAGER: 'INSURER_HEAD_MANAGER',
    INSURER_DEPUTY_LEADER: 'INSURER_DEPUTY_LEADER',
    INSURER_BRANCH_MANAGER: 'INSURER_BRANCH_MANAGER',
    INSURER_DEPUTY_BRANCH_MANAGER: 'INSURER_DEPUTY_BRANCH_MANAGER',
    INSURER_EDUCATION_MANAGER: 'INSURER_EDUCATION_MANAGER',
    INSURER_PLANNER: 'INSURER_PLANNER',
    INSURER_PLAN_MANAGER: 'INSURER_PLAN_MANAGER',
    INSURER_OTHER_ADMIN: 'INSURER_OTHER_ADMIN',
    INSURER_ETC: 'INSURER_ETC',
}

export const Capabilities = {
    PROFILE: 'PROFILE',
    NOTICE: 'NOTICE',
    COUNTERPART: 'COUNTERPART',
    REQUEST: 'REQUEST',
    HEALTH_ANALYSIS: 'HEALTH_ANALYSIS',
    BILLING: 'BILLING',
    INSURANCE_NEWS: 'INSURANCE_NEWS',
}

export const Permissions = {
    DASHBOARD_VIEW: 'DASHBOARD_VIEW',
    REPORT_VIEW: 'REPORT_VIEW',
    ORG_MANAGE: 'ORG_MANAGE',
    USER_INVITE: 'USER_INVITE',
    REQUEST_CREATE: 'REQUEST_CREATE',
    REQUEST_REASSIGN: 'REQUEST_REASSIGN',
    REQUEST_CANCEL: 'REQUEST_CANCEL',
    REQUEST_COMPLETE: 'REQUEST_COMPLETE',
    NOTICE_CREATE: 'NOTICE_CREATE',
    NOTICE_APPROVE: 'NOTICE_APPROVE',
    NOTICE_SEND: 'NOTICE_SEND',
    NOTICE_LOG_VIEW: 'NOTICE_LOG_VIEW',
    TEMPLATE_MANAGE: 'TEMPLATE_MANAGE',
    COUNTERPART_VIEW: 'COUNTERPART_VIEW',
    COUNTERPART_NOTE: 'COUNTERPART_NOTE',
    ORG_BANNER_MANAGE: 'ORG_BANNER_MANAGE',
}

// 역할별 권한 매핑(백엔드 @PreAuthorize 정책과 동기화)
// NOTE: RolePermissions 초기화 도중 RolePermissions를 참조하면 런타임 에러(TDZ) 발생 → 공통 세트를 상수로 분리.
const PERMS_OPERATOR = [
    Permissions.DASHBOARD_VIEW,
    Permissions.REPORT_VIEW,
    Permissions.ORG_MANAGE,
    Permissions.USER_INVITE,
    Permissions.REQUEST_CREATE,
    Permissions.REQUEST_REASSIGN,
    Permissions.REQUEST_CANCEL,
    Permissions.REQUEST_COMPLETE,
    Permissions.NOTICE_CREATE,
    Permissions.NOTICE_APPROVE,
    Permissions.NOTICE_SEND,
    Permissions.NOTICE_LOG_VIEW,
    Permissions.TEMPLATE_MANAGE,
    Permissions.COUNTERPART_VIEW,
    Permissions.COUNTERPART_NOTE,
]

const PERMS_ADMIN = [
    Permissions.DASHBOARD_VIEW,
    Permissions.REPORT_VIEW,
    Permissions.ORG_MANAGE,
    Permissions.USER_INVITE,
    Permissions.TEMPLATE_MANAGE,
    Permissions.REQUEST_CREATE,
    Permissions.REQUEST_REASSIGN,
    Permissions.REQUEST_CANCEL,
    Permissions.REQUEST_COMPLETE,
    Permissions.NOTICE_CREATE,
    Permissions.NOTICE_APPROVE,
    Permissions.NOTICE_SEND,
    Permissions.NOTICE_LOG_VIEW,
    Permissions.COUNTERPART_VIEW,
    Permissions.COUNTERPART_NOTE,
]

const PERMS_SUBADMIN = [
    Permissions.DASHBOARD_VIEW,
    Permissions.REPORT_VIEW,
    Permissions.ORG_MANAGE,
    Permissions.USER_INVITE,
    Permissions.TEMPLATE_MANAGE,
    Permissions.REQUEST_CREATE,
    Permissions.REQUEST_REASSIGN,
    Permissions.REQUEST_COMPLETE,
    Permissions.NOTICE_CREATE,
    Permissions.NOTICE_SEND,
    Permissions.NOTICE_LOG_VIEW,
    Permissions.COUNTERPART_VIEW,
    Permissions.COUNTERPART_NOTE,
]

const PERMS_MANAGER = [
    Permissions.DASHBOARD_VIEW,
    Permissions.REPORT_VIEW,
    Permissions.ORG_MANAGE,
    Permissions.USER_INVITE,
    Permissions.TEMPLATE_MANAGE,
    Permissions.REQUEST_CREATE,
    Permissions.REQUEST_REASSIGN,
    Permissions.REQUEST_COMPLETE,
    Permissions.NOTICE_CREATE,
    Permissions.NOTICE_SEND,
    Permissions.NOTICE_LOG_VIEW,
    Permissions.COUNTERPART_VIEW,
    Permissions.COUNTERPART_NOTE,
]

const PERMS_PLANNER = [
    Permissions.DASHBOARD_VIEW,
    Permissions.REPORT_VIEW,
    Permissions.REQUEST_CREATE,
    Permissions.REQUEST_COMPLETE,
    Permissions.NOTICE_LOG_VIEW,
    Permissions.COUNTERPART_VIEW,
]

const PERMS_ETC = [
    Permissions.DASHBOARD_VIEW,
    Permissions.REPORT_VIEW,
]

export const RolePermissions = {
    [Roles.OPERATOR]: [...PERMS_OPERATOR],

    // GA
    [Roles.GA_MASTER_ADMIN]: [...PERMS_ADMIN],
    [Roles.GA_MASTER_DEPUTY_ADMIN]: [...PERMS_SUBADMIN],
    [Roles.GA_LEADER]: [...PERMS_ADMIN],
    [Roles.GA_DEPUTY_LEADER]: [...PERMS_SUBADMIN],
    [Roles.GA_BRANCH_MANAGER]: [...PERMS_ADMIN],
    [Roles.GA_DEPUTY_BRANCH_MANAGER]: [...PERMS_SUBADMIN],
    [Roles.GA_OTHER_ADMIN]: [...PERMS_ADMIN],
    [Roles.GA_MANAGER]: [...PERMS_ADMIN],
    [Roles.GA_OPERATION_MANAGER]: [...PERMS_MANAGER],
    [Roles.GA_PLANNER]: [...PERMS_PLANNER],
    [Roles.GA_ETC]: [...PERMS_ETC],

    // INSURER
    [Roles.INSURER_MASTER_ADMIN]: [...PERMS_ADMIN],
    [Roles.INSURER_MASTER_DEPUTY_ADMIN]: [...PERMS_SUBADMIN],
    [Roles.INSURER_LEADER]: [...PERMS_ADMIN],
    [Roles.INSURER_DEPUTY_LEADER]: [...PERMS_SUBADMIN],
    [Roles.INSURER_BRANCH_MANAGER]: [...PERMS_ADMIN],
    [Roles.INSURER_DEPUTY_BRANCH_MANAGER]: [...PERMS_SUBADMIN],
    [Roles.INSURER_OTHER_ADMIN]: [...PERMS_ADMIN],
    [Roles.INSURER_MANAGER]: [...PERMS_ADMIN],
    [Roles.INSURER_OPERATION_MANAGER]: [...PERMS_MANAGER],
    [Roles.INSURER_EDUCATION_MANAGER]: [...PERMS_MANAGER],
    [Roles.INSURER_PLANNER]: [...PERMS_PLANNER],
    [Roles.INSURER_PLAN_MANAGER]: [...PERMS_PLANNER],
    [Roles.INSURER_ETC]: [...PERMS_ETC],
}

// 한글 라벨 매핑
export const RoleLabels = {
    [Roles.OPERATOR]: '운영자',
    [Roles.GA_MASTER_ADMIN]: 'GA 마스터 관리자',
    [Roles.GA_MASTER_DEPUTY_ADMIN]: 'GA 마스터 부관리자',
    // GA 4단계 라벨(정책)
    [Roles.GA_LEADER]: 'GA 대표',
    [Roles.GA_MANAGER]: 'GA 관리자',
    [Roles.GA_OPERATION_MANAGER]: 'GA 매니저',
    [Roles.GA_AFFAIRS]: 'GA 총무(레거시)',
    [Roles.GA_PLANNER]: 'GA 설계사',

    // (레거시/호환) - 신규 사용은 3단계만
    [Roles.GA_DEPUTY_LEADER]: 'GA 사업부단장(레거시)',
    [Roles.GA_BRANCH_MANAGER]: 'GA 지점장',
    [Roles.GA_DEPUTY_BRANCH_MANAGER]: 'GA 부지점장',
    [Roles.GA_OTHER_ADMIN]: 'GA 기타 관리자',
    [Roles.GA_ETC]: '기타 GA 담당자',
    // 원수사 4단계 라벨(정책)
    [Roles.INSURER_LEADER]: '원수사 대표',
    [Roles.INSURER_MANAGER]: '원수사 관리자',
    [Roles.INSURER_OPERATION_MANAGER]: '원수사 매니저',
    [Roles.INSURER_PLANNER]: '원수사 설계사',
    [Roles.INSURER_HEAD_MANAGER]: '원수사 본부장(레거시)',

    // (레거시/호환) - 신규 사용은 4단계만
    [Roles.INSURER_MASTER_ADMIN]: '원수사 마스터 관리자(레거시)',
    [Roles.INSURER_MASTER_DEPUTY_ADMIN]: '원수사 마스터 부관리자(레거시)',
    [Roles.INSURER_DEPUTY_LEADER]: '원수사 사업부단장(레거시)',
    [Roles.INSURER_BRANCH_MANAGER]: '원수사 관리자(레거시)',
    [Roles.INSURER_DEPUTY_BRANCH_MANAGER]: '원수사 부지점장(레거시)',
    [Roles.INSURER_EDUCATION_MANAGER]: '원수사 교육매니저(레거시)',
    [Roles.INSURER_PLAN_MANAGER]: '원수사 설계사(레거시)',
    [Roles.INSURER_OTHER_ADMIN]: '원수사 기타 관리자(레거시)',
    [Roles.INSURER_ETC]: '기타 원수사 담당자(레거시)',
}

export function getRoleLabel(role) {
    try {
        const stored = typeof window !== 'undefined' ? localStorage.getItem('meta.roles') : null
        if (stored) {
            const arr = JSON.parse(stored)
            const found = Array.isArray(arr) ? arr.find((r) => r.code === role) : null
            if (found && found.labelKo) return found.labelKo
        }
    } catch { }
    return RoleLabels[role] || role
}

export function getRoleLabels(roles) {
    if (!Array.isArray(roles)) return []
    return roles.map((r) => getRoleLabel(r))
}

export function getUserRoles(user) {
    // 서버/로컬 저장 형태가 환경마다 조금씩 달라져도(문자열/객체/단일값) 안정적으로 역할 코드를 뽑아낸다.
    // - 권장 형태: user.effectiveRoles = ['OPERATOR', 'GA_LEADER', ...]
    // - 호환 형태: user.roles = [{ code: 'OPERATOR' }, ...] 또는 user.role = 'OPERATOR'
    const candidates = [
        user?.effectiveRoles,
        user?.effective_roles,
        user?.roles,
        user?.userRoles,
        user?.role,
    ]
    const raw = candidates.find((value) => Array.isArray(value) || typeof value === 'string') || []

    const arr = Array.isArray(raw) ? raw : (raw ? [raw] : [])
    return arr
        .map((r) => {
            if (!r) return null
            if (typeof r === 'string') return r
            if (typeof r === 'object') {
                // 자주 쓰이는 키들을 우선순위로 처리
                return r.code || r.role || r.name || null
            }
            return String(r)
        })
        .filter(Boolean)
}

export function getUserPermissions(user) {
    // 서버가 내려주는 실효 권한(권장): /users/me -> permissions
    // - 권한관리 UI(role_permissions) 변경이 즉시 FE에 반영되도록 한다.
    const serverPerms = user?.permissions
    if (Array.isArray(serverPerms)) {
        const set = new Set()
        serverPerms.forEach((p) => {
            if (p) set.add(String(p))
        })
        return Array.from(set)
    }

    // 하위호환: 서버가 permissions를 아직 제공하지 않는 환경에서는 기존 역할 기반 매핑을 사용
    const roles = getUserRoles(user)
    const set = new Set()
    roles.forEach((r) => {
        const perms = RolePermissions[r] || []
        perms.forEach((p) => set.add(p))
    })
    return Array.from(set)
}

export function hasAnyRole(user, roles) {
    const userRoles = getUserRoles(user)
    return roles.some((r) => userRoles.includes(r))
}

export function hasAllRoles(user, roles) {
    const userRoles = getUserRoles(user)
    return roles.every((r) => userRoles.includes(r))
}

export function hasPermission(user, permission) {
    const perms = getUserPermissions(user)
    return perms.includes(permission)
}

export function getUserCapabilities(user) {
    const raw = user?.capabilities
    const arr = Array.isArray(raw) ? raw : []
    return arr.map(String).filter(Boolean)
}

export function hasCapability(user, capability) {
    return getUserCapabilities(user).includes(String(capability))
}

export function hasAnyCapability(user, capabilities) {
    const current = getUserCapabilities(user)
    return (capabilities || []).some((cap) => current.includes(String(cap)))
}

/**
 * BE UserController.resolveCapabilities: 통신전용이 아니면 REQUEST·HEALTH_ANALYSIS·INSURANCE_NEWS·BILLING 를 함께 부여.
 * serviceProfile이 없으면 FULL_SERVICE로 간주한다(레거시 캐시/구형 응답 호환).
 */
export function usesOrgFullServiceFeatures(user) {
    if (!user) return false
    if (user.serviceProfile === 'COMMUNICATION_ONLY') return false
    if (user.serviceProfile == null) return true
    if (user.serviceProfile === 'FULL_SERVICE') return true
    return hasCapability(user, Capabilities.REQUEST)
}

export function hasHealthAnalysisAccess(user) {
    if (!user) return false
    if (hasAnyRole(user, [Roles.OPERATOR])) return true
    if (hasCapability(user, Capabilities.HEALTH_ANALYSIS)) return true
    return usesOrgFullServiceFeatures(user)
}

export function hasInsuranceNewsAccess(user) {
    if (!user) return false
    if (hasAnyRole(user, [Roles.OPERATOR])) return true
    if (hasCapability(user, Capabilities.INSURANCE_NEWS)) return true
    return usesOrgFullServiceFeatures(user)
}

export function hasAnyPermission(user, permissions) {
    const perms = getUserPermissions(user)
    return permissions.some((p) => perms.includes(p))
}


